import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatNumber, getAmountLabelForNumber } from 'utils'

function Revenue({ revenueCurrent, currency }) {
  const { t: translate } = useTranslation()

  return (
    <span className="search-list_item-revenue">
      {formatNumber(revenueCurrent, translate)} {getAmountLabelForNumber(revenueCurrent, translate, currency)}
    </span>
  )
}

Revenue.propTypes = {
  currency: PropTypes.string,
  revenueCurrent: PropTypes.number,
}

export default Revenue
